import { render, staticRenderFns } from "./NewsLeft.vue?vue&type=template&id=792978f8&scoped=true&"
import script from "./NewsLeft.vue?vue&type=script&lang=js&"
export * from "./NewsLeft.vue?vue&type=script&lang=js&"
import style0 from "./NewsLeft.vue?vue&type=style&index=0&id=792978f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792978f8",
  null
  
)

export default component.exports